export const CHARGER_STATUS = 'CHARGER_STATUS';
export const CHARGER_STATUS_SUCCESS = 'CHARGER_STATUS_SUCCESS';
export const CHARGER_STATUS_FAIL = 'CHARGER_STATUS_FAIL';